export const DEFAULT_WORK_SCHEDULE = {
  1: { enabled: true, start: "09:30", end: "18:00" },
  2: { enabled: true, start: "09:30", end: "18:00" },
  3: { enabled: true, start: "09:30", end: "18:00" },
  4: { enabled: true, start: "09:30", end: "18:00" },
  5: { enabled: true, start: "09:30", end: "18:00" },
  6: { enabled: false, start: "09:30", end: "18:00" },
  7: { enabled: false, start: "09:30", end: "18:00" },
};

export const WORK_DAY_LABELS = [
  { id: 1, label: "Pazartesi" },
  { id: 2, label: "Salı" },
  { id: 3, label: "Çarşamba" },
  { id: 4, label: "Perşembe" },
  { id: 5, label: "Cuma" },
  { id: 6, label: "Cumartesi" },
  { id: 7, label: "Pazar" },
];

export const cloneWorkSchedule = (schedule) => {
  const base = schedule || DEFAULT_WORK_SCHEDULE;
  return WORK_DAY_LABELS.reduce((acc, day) => {
    const row = base[day.id] || base[String(day.id)] || DEFAULT_WORK_SCHEDULE[day.id];
    acc[day.id] = {
      enabled: !!row?.enabled,
      start: row?.start || "09:30",
      end: row?.end || "18:00",
    };
    return acc;
  }, {});
};

export const formatWorkScheduleSummary = (schedule) => {
  const ws = cloneWorkSchedule(schedule);
  const active = WORK_DAY_LABELS.filter((d) => ws[d.id]?.enabled);
  if (active.length === 0) return "Mesai tanımlı değil";
  const first = ws[active[0].id];
  const sameHours = active.every((d) => ws[d.id].start === first.start && ws[d.id].end === first.end);
  const weekdaysOnly = active.length === 5 && !ws[6]?.enabled && !ws[7]?.enabled;
  const dayStr = weekdaysOnly ? "Hafta içi" : active.map((d) => d.label.slice(0, 3)).join(", ");
  return sameHours ? `${dayStr} · ${first.start} – ${first.end}` : `${active.length} gün (özel plan)`;
};
